import { getDeliveryDefaultLink } from "@cirrus/common/DeliveryV2Enabled"
import { getConfig } from "@cirrus/config"

import { getLink } from "./getLink"
import { userRoleTypes } from "../../constants"

export function toApp(result, stayLoggedIn = false) {
  const { access_token, exam_url, user_role } = result
  const authorConfig = getConfig("author")
  const deliveryConfig = getConfig("delivery")

  switch (user_role) {
    case userRoleTypes.author: {
      sessionStorage.setItem(authorConfig.TokenKey, access_token)
      window.location.href = "/author/app"
      return
    }

    case userRoleTypes.delivery: {
      sessionStorage.setItem(deliveryConfig.TokenKey, access_token)
      location.href = result.redirect_to_type ? getLink(result) : getDeliveryDefaultLink()
      return
    }

    case userRoleTypes.all: {
      sessionStorage.setItem(authorConfig.TokenKey, access_token)
      sessionStorage.setItem(deliveryConfig.TokenKey, access_token)
      const parameter = stayLoggedIn ? "?stayLoggedIn=true" : ""

      window.location.href = `/${parameter}#role`
      return
    }
  }
}

export default toApp